import React, { FC } from 'react';

interface IComponentProps {
  id: string;
  label: string;
  icon: React.ReactNode;
  checked: boolean;
  onChange: (value: string) => void;
}

export const PaymentTab: FC<IComponentProps> = ({ id, label, icon, checked, onChange }) => {
  return (
    <label className={`payment-layout__tabs-tab ${checked ? 'active' : ''}`}>
      <input id={id} type="radio" name="tabs" checked={checked} onChange={() => onChange(id)} />

      {icon}

      <span>{label}</span>
    </label>
  );
};
